import styled from "styled-components";

const AddTravelerWrapper = styled.div`
  .container-fluid {
    text-align: initial;
  }
  .titleStyle {
    font-size: 32px;
    font-weight: 700;
    color: #6b47f5;
    padding-top: 30px;
    padding-bottom: 30px;
  }
  .inputField {
    margin-top: 20px;
    margin-bottom: 20px;
  }
  .buttonDiv {
    height: 50px !important;
    margin-top: 20px;
  }
  .buttonDivSave {
    margin-top: 20px;
  }
  .buttonSave {
    height: 50px !important;
    background: #6b47f5;
    border: #6b47f5;
  }
  .buttonCancel {
    color: #6b47f5;
    background: #fff;
    border-color: #6b47f5;
  }
  .buttonSave:hover {
    background: #6b47f5;
  }
  .buttonCancel:hover {
    background: #6b47f5;
  }
  .p-calendar-w-btn-right .p-datepicker-trigger {
    border-radius: 0;
  }
  .p-fluid .p-calendar .p-inputtext {
    width: 1%;
    border-radius: 0px;
  }
  .dropdown-rtl {
    text-align: right;
  }
  .dropdown {
    text-align: left;
  }

  .custom-calendar-input {
    input {
      border-right: none;
    }
    .p-button-icon-only {
      padding: 0;
      background: transparent;
      color: rgb(110, 159, 187);
      border-left: none;
      border-radius: 0;
      border-color: #ced4da;
      :focus {
        box-shadow: none;
      }
    }

    &.p-invalid {
      .p-button-icon-only {
        border-color: red;
        color: red;
      }
    }
  }
  .p-float-label .p-inputwrapper-filled ~ label {
    left: 0 !important;
  }
  .ar {
  }
  @media only screen and (max-width: 576px) {
    .ar {
      .titleStyle {
        font-size: 20px;
      }
      .custom-calendar-input input {
        border-right: 1px solid #ced4da;
        border-left: none;
      }
      .custom-calendar-input .p-button-icon-only {
        border-left: 1px solid #ced4da;
        border-right: none;
        border-radius: 0;
      }
    }
  }
`;

export default AddTravelerWrapper;
